import { render, staticRenderFns } from "./mainPopup.vue?vue&type=template&id=09e6cc62&scoped=true"
import script from "./mainPopup.vue?vue&type=script&lang=js"
export * from "./mainPopup.vue?vue&type=script&lang=js"
import style0 from "./mainPopup.vue?vue&type=style&index=0&id=09e6cc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e6cc62",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/var/www/html/jayuvillage/components/modal.vue').default})
